import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, LockIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-121" data-mp="4m8kg77n0hia">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-122" data-mp="129h2fs8fj8fj">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-blue-600 md:text-lg" data-id="element-123" data-mp="127eereur1rdz">
          <SparklesIcon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-124" data-mp="neav91xll3km" />
          BIO-RESET 5.0™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.5rem] font-extrabold leading-[1.03] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-125" data-mp="382p6bf4uvhm7">
          Deja de sentirte una extraña
          <br data-id="element-126" data-mp="39a36gxl5v9lq" />
          <span className="text-gold-600" data-id="element-127" data-mp="39cpcutwbfj2d">en tu propio cuerpo</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.12,
        ease
      }} src={heroImage} alt="MegaPack BIO-RESET 5.0: caja del sistema, los 6 tomos y los 6 bonos incluidos" className="mx-auto mt-10 w-full max-w-2xl" width={1256} height={1256} data-id="element-128" data-mp="3e7l8s54oaqkr" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-129" data-mp="2vgu1ra85rc9j">
          <p className="font-display text-2xl font-extrabold leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-130" data-mp="s21iabtr0dzz">
            El protocolo de rescate para la mujer que no reconoce su reflejo
          </p>
          <p className="mt-5 text-xl leading-relaxed text-ink md:text-2xl" data-id="element-131" data-mp="ibyq2dugb42p">
            MegaPack: 6 Tomos + 6 Bonos. Todo listo para empezar hoy.
          </p>

          <div className="mt-10" data-id="element-132" data-mp="deyjm1tovzb2">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-133" data-mp="1b0nkju104b5h">
              Quiero mi BIO-RESET ahora
            </CtaButton>
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-134" data-mp="163454qskhsby">
            <li className="inline-flex items-center gap-1.5" data-id="element-135" data-mp="114svag29vhtq">
              <ZapIcon className="h-4 w-4 text-gold-600" aria-hidden="true" data-id="element-136" data-mp="x0cqyj8b4igm" /> Acceso inmediato
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-137" data-mp="3luiaiu6w15my">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-138" data-mp="3hqu1e72ly1zl" /> Pago 100% seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-139" data-mp="1xacfj35u5jt8">
              <ShieldCheckIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-140" data-mp="21awdg8y8grgf" /> Garantía 7
              días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="269r23rivta8g">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-142" data-mp="2b0pmp3awkuhi" /> Mercado Pago
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}